import { Component, ChangeDetectorRef, AfterContentChecked, ViewChild, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { MainScrollService } from "src/app/services/Common/main-scroll.service";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { SmsForClient } from "src/classes/Automation/sms_setting";
import { CustCard_3 } from "src/classes/Customers/CustCard_3";

@Component({
    selector: "app-custcard",
    templateUrl: "./custcard.component.html",
    styleUrls: ["./custcard.component.css"],
    providers: [HttpServiceCustomer, HttpService1, MessageService]
})

export class CustcardComponent implements OnInit, AfterContentChecked {
    customerId: number;
    custcard_3: CustCard_3 = new CustCard_3();

    isScrolled: boolean = false;
    isHeaaderHidden: boolean = false;
    isNotificationTabChosen: boolean = false;

    sms: SmsForClient = new SmsForClient();
    receivedsms: SmsForClient = new SmsForClient();
    isDialogVisible: boolean = false;
    isDialogErrorVisible: boolean = false;
    smsMessage: string = "";

    @ViewChild("smsInput", { static: false }) smsInput: ElementRef<HTMLInputElement>;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    constructor(private activatedRoute: ActivatedRoute,
        private mainScroll: MainScrollService,
        private custCardTabService: CustCardTabService,
        private changeDetector: ChangeDetectorRef,
        private httpServiceCustomer: HttpServiceCustomer,
        private httpService1: HttpService1,
        private messageService: MessageService,
        private logger: NGXLogger
    ) {
        activatedRoute.params.subscribe((params: Params) => this.customerId = params["id"]);
        console.log("CustomerID: " + this.customerId);

        activatedRoute.queryParams.subscribe((params: Params) => {
            setTimeout(() => {
                if (params["isEdited"]) {
                    this.showMessage("success", "עדכון/הוספת לקוח/ה בוצע בהצלחה");
                }
                else if (params["isCreated"]) {
                    this.showMessage("success", "עדכון/הוספת לקוח/ה בוצע בהצלחה");
                }
            }, 0);
        });

        mainScroll.scrollChanged.subscribe((status: number) => this.onWindowScroll(status));
        custCardTabService.notificationTabChanged.subscribe((tabIndex: number) => this.onChangeTab(tabIndex));
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onChangePanel(tabIndex));
    }

    ngOnInit(): void {
        // Get custcard_3 data
        this.httpServiceCustomer.getCustCard_3({ customer_id: this.customerId })
            .subscribe((res: CustCard_3) => {
                this.custcard_3 = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

    onWindowScroll(status: number): void {
        if (status > 10) {
            this.isScrolled = true;
        }
        else if (this.isScrolled && status < 10) {
            this.isScrolled = false;
        }
    }

    onChangeTab(tabIndex: number): void {
        if (tabIndex == 0 || tabIndex == 1) {
            this.isNotificationTabChosen = true;
        }
        else {
            this.isNotificationTabChosen = false;
        }
    }

    onChangePanel(tabIndex: number): void {
        if (tabIndex != 57) {
            this.isHeaaderHidden = true;
        } else {
            this.isHeaaderHidden = false
        }
    }

    openSmsDialog(): void {
        this.isDialogVisible = true;

        setTimeout(() => {
            this.smsInput.nativeElement.focus();
        }, 50);
    }

    hideSmsDialog(isSubmited: boolean): void {
        if (isSubmited) {
            if (this.smsMessage.trim() != "") {
                this.isDialogErrorVisible = false;
                this.isDialogVisible = false;
                this.sendSmsClient(this.smsMessage);
                this.smsMessage = "";
            }
            else {
                this.isDialogErrorVisible = true;
            }
        }
        else {
            this.isDialogErrorVisible = false;
            this.isDialogVisible = false;
            this.smsMessage = "";
        }
    }

    sendSmsClient(smsMessage: string): void {
        this.sms.businessEmail = sessionStorage.getItem("email");
        this.sms.customerId = this.custcard_3.customerId;
        this.sms.pelephone = this.custcard_3.pelephone;
        this.sms.txtMessage = smsMessage;

        this.httpService1.SendMessageClient(this.sms)
            .then((res: SmsForClient) => {
                this.receivedsms = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }
}
